/**
 * Filters and adjusts select options using per-option `override` maps (e.g. by size).
 * Shared by ProductPage-style flows and quote catalog rules fallback.
 */
export function getOptionListByOverride(options, overrides) {
  const arr = [];
  for (const option of options) {
    let keep = true;
    if (overrides && option.override) {
      for (const [key, value] of Object.entries(overrides)) {
        if (option.override[key] && option.override[key][value]) {
          if (String(option.override[key][value].allow) === "false") {
            keep = false;
            continue;
          } else if (option.override[key][value].amount) {
            option.pricing = { type: "fixed", amount: option.override[key][value].amount };
          }
        }
      }
    }
    if (keep) {
      arr.push(option);
    }
  }
  return arr;
}

/**
 * Photo field pricing matches select options: size-override amount if present,
 * otherwise the field's flat-rate pricing.
 */
export function getPhotoPricingForSize(field, sizeName) {
  const szOvr = sizeName && field?.override?.size?.[sizeName];
  if (szOvr?.amount) {
    return { amount: szOvr.amount, type: "surcharge" };
  }
  return field?.pricing;
}
